<template>
  <BaseForm :model="formData" @loading="handleLoading">
    <FormHeader :title="_e('header_title')" :back-url="_e('header_back_url')" :image="_e('form_header_image')"></FormHeader>

    <FormBody>
      <h3 class="form-sec-title col--wide">{{ _e('title_basic_data', 'Dados Pessoais') }}</h3>
      <BasicInput type="text" required v-model="model.nome" class="col--wide col--md-8"
        :label="_e('label_name', 'Nome Completo')"
        :placeholder="_e('ph_name', 'Ex.: Carlos Almeida')">
      </BasicInput>

      <BasicInput type="text" required v-model="model.cnpj" class="col--wide col--md-4"
        :label="_e('label_cnpj', 'CNPJ')"
        :placeholder="_e('ph_cnpj', '00.000.000/0000-00')"
        :mask="'##.###.###/####-##'">
      </BasicInput>

      <BasicInput type="email" required v-model="model.email" class="col--wide col--md-8"
        :label="_e('label_email', 'Email')"
        :placeholder="_e('ph_email', 'Ex.: carlos@email.com')">
        <template #prefix>
          <Icons name="mail" />
        </template>
      </BasicInput>

      <BasicInput type="text" required v-model="model.telefone" class="col--wide col--md-4"
        :label="_e('label_phone', 'Whatsapp')"
        :placeholder="_e('ph_phone', '+55 (00) 00000-0000')"
        :mask="['(##) #####-####', '(##) ####-####']">
        <template #prefix>
          <Icons name="phone" />
        </template>
      </BasicInput>

      <h3 class="form-sec-title col--wide">{{ _e('title_address_data', 'Dados de Endereço') }}</h3>

      <BasicInput type="text" required v-model="model.cep" class="col--wide col--md-3"
        :label="_e('label_cep', 'CEP')"
        :placeholder="_e('ph_cep', '90000-000')"
        :mask="'#####-###'">
      </BasicInput>

      <DropdownInput class="col--wide col--md-6 col--new-row" required
        @change="stateChangeHandle"
        :label="_e('label_estado', 'Estado')"
        :placeholder="_e('ph_estado', 'Selecione o Estado')"
        :options="cep.estados"
        v-model="model.estado">
      </DropdownInput>

      <DropdownInput class="col--wide col--md-6" required
        :label="_e('label_cidade', 'Cidade')"
        :placeholder="_e('ph_cidade', 'Selecione a Cidade')"
        :placeholder-loading="_e('loading', 'Carregando...')"
        :options="cep.cidades"
        :options-loading="isCepLoading"
        v-model="model.cidade">
      </DropdownInput>

      <TextareaInput v-model="model.mensagem" class="col--wide"
        :label="_e('label_message', 'Mensagem')"
        :placeholder="_e('ph_message', 'Digite aqui sua mensagem')">
      </TextareaInput>

      <div class="col--wide">
        <CheckInput :options="termsConditions" v-model="model.terms" :required="true"></CheckInput>
      </div>

      <div class="col--wide col--md-5 col--jss">
        <VueTurnstile :site-key="config.TURNSTILE_KEY" v-model="token" theme="light"></VueTurnstile>
      </div>

      <div class="col--wide col--md-7 col--md-jse col--asc">
        <SubmitButton :is-loading="isLoading">{{ _e('form_submit', 'Enviar') }}</SubmitButton>
      </div>
    </FormBody>
  </BaseForm>
</template>

<script setup>
import { ref, computed, reactive } from 'vue';
import { _e } from '../helpers/l10n';
import config from '../helpers/config';
import { useCepStore } from '../store/CepStore';

import VueTurnstile from 'vue-turnstile';

import BasicInput from '../components/form/inputs/BaseInput.vue';
import DropdownInput from '../components/form/inputs/DropdownInput.vue';
import TextareaInput from '../components/form/inputs/TextareaInput.vue';
import CheckInput from '../components/form/inputs/CheckInput.vue';
import BaseForm from '../components/form/BaseForm.vue';
import SubmitButton from '../components/form/SubmitButton.vue';
import Icons from '../components/icons/Icons.vue';
import FormHeader from '../components/sections/FormHeader.vue';
import FormBody from '../components/sections/FormBody.vue';

const cep = useCepStore();

const isCepLoading = ref(false);

const stateChangeHandle = async ()=>{
  isCepLoading.value = true;
  if(model.estado) {
    await cep.loadCidades(model.estado);
  } else {
    model.cidade = '';
  }
  isCepLoading.value = false;
};

const termsConditions = _e('termos_condicoes');

const token = ref('');
const isLoading = ref(false);

const model = reactive({
  nome: '',
  cnpj: '',
  email: '',
  telefone: '',
  cep: '',
  estado: '',
  cidade: '',
  mensagem: '',
  terms: false
});

function handleLoading(isFormLoading) {
  isLoading.value = isFormLoading;
}

const formData = computed(() => {
  const formData = new FormData();
    formData.append('nome', model.nome);
    formData.append('cnpj', model.cnpj);
    formData.append('email', model.email);
    formData.append('telefone', model.telefone);
    formData.append('cep', model.cep);
    formData.append('estado', model.estado);
    formData.append('cidade', model.cidade);
    formData.append('mensagem', model.mensagem);
    formData.append('terms', model.terms);
    formData.append('cf_token', token.value);

  return formData;
});
</script>
